import { StateBasedProps, StateType } from './ButtonContent';
import { DEFAULT_COLORS } from './ButtonContent.constants';

//function to for statebased prop
export function getStateBasedProp<T>(
  prop: T | StateBasedProps<T> | undefined,
  state: StateType,
): T | undefined {
  if (!prop) return undefined;
  if (typeof prop === 'object' && prop !== null && 'default' in prop) {
    return state === 'hover' && prop.hover ? prop.hover : prop.default;
  }
  return prop as T;
}

//function to add state based properties
export function updateStateBasedProp<T>(
  currentProp: T | StateBasedProps<T> | undefined,
  updates: T | Partial<T>,
  state: StateType,
  propType?: 'text' | 'icon' | 'image' | 'container',
  isFullValue: boolean = false,
): StateBasedProps<T> {
  let stateBasedProp: StateBasedProps<T>;

  if (currentProp && typeof currentProp === 'object' && 'default' in currentProp) {
    stateBasedProp = { ...currentProp };
  } else {
    stateBasedProp = {
      default: (currentProp as T) || (isFullValue ? (updates as T) : ({} as T)),
    };
  }

  if (state === 'default') {
    stateBasedProp.default = isFullValue
      ? (updates as T)
      : { ...stateBasedProp.default, ...updates };
  } else {
    if (isFullValue) {
      stateBasedProp.hover = updates as T;
    } else {
      let defaultHoverValues = {};

      if (propType === 'text' && (updates as any).color) {
        defaultHoverValues = { color: DEFAULT_COLORS.textHover };
      } else if (propType === 'icon' && (updates as any).color) {
        defaultHoverValues = { color: DEFAULT_COLORS.iconHover };
      } else if (propType === 'image') {
        defaultHoverValues = {
          opacity: DEFAULT_COLORS.opacityHover,
        };
      } else if (propType === 'container') {
        if ((updates as any).backgroundColor) {
          defaultHoverValues = { backgroundColor: DEFAULT_COLORS.backgroundColorHover };
        }
        if ((updates as any).borderColor) {
          defaultHoverValues = {
            ...defaultHoverValues,
            borderColor: DEFAULT_COLORS.borderColorHover,
          };
        }
      }

      stateBasedProp.hover = {
        ...(stateBasedProp.hover || stateBasedProp.default),
        ...defaultHoverValues,
        ...updates,
      };
    }
  }

  return stateBasedProp;
}

//function to get default color or default properties

export function getDefaultColor(
  type: 'text' | 'icon' | 'opacity' | 'background' | 'border',
  currentColor: string | Number,
  state: StateType,
): string | Number {
  if (currentColor) return currentColor;

  const hoverColors = {
    text: DEFAULT_COLORS.textHover,
    icon: DEFAULT_COLORS.iconHover,
    background: DEFAULT_COLORS.backgroundColorHover,
    border: DEFAULT_COLORS.borderColorHover,
    opacity: DEFAULT_COLORS.opacityHover,
  };

  const defaultColors = {
    text: DEFAULT_COLORS.text,
    icon: DEFAULT_COLORS.icon,
    background: DEFAULT_COLORS.backgroundColor,
    border: DEFAULT_COLORS.borderColor,
    opacity: DEFAULT_COLORS.opacity,
  };

  return state === 'hover' ? hoverColors[type] : defaultColors[type];
}
